import { handleActions } from 'redux-actions';
import { defaultDeactivateAccountWidgetState } from './defaults';
import {
  DeactivateAccountWidgetData,
  DeactivateAccountWidgetStep,
} from './types';
import {
  initDeactivationConfirmationPage,
  initDeactivationPage,
} from '../../actions';
import {
  setDeactivateAccountWidgetStep,
  submitConfirmDeactivationModalSuccess,
  submitConfirmDeactivationModalFailure,
  submitConfirmDeactivationModal,
  submitSendVerificationEmailModalSuccess,
  submitSendVerificationEmailModalFailure,
  submitSendVerificationEmailModal,
  submitReactivateFailure,
  submitReactivateSuccess,
  submitReactivate,
} from './actions';
import { networkRequestMetaReducer } from '../utils';

function determineCurrentStepForNormalInit(
  initAction: ReturnType<typeof initDeactivationPage>
) {
  const { canReactivate, timeUntilReactivation } = initAction.payload.data;
  if (timeUntilReactivation > 0 || canReactivate) {
    return DeactivateAccountWidgetStep.Reactivate;
  } else {
    return DeactivateAccountWidgetStep.Initial;
  }
}

export default handleActions<DeactivateAccountWidgetData, any>(
  {
    [initDeactivationPage.toString()]: (
      state,
      action: ReturnType<typeof initDeactivationPage>
    ) => {
      return {
        ...state,
        canReactivate: action.payload.data.canReactivate,
        timeUntilReactivation: action.payload.data.timeUntilReactivation,
        step: determineCurrentStepForNormalInit(action),
        isDeactivated: action.payload.data.isDeactivated,
        timeUntilReactivationEnds:
          action.payload.data.timeUntilReactivationEnds,
        linkSource: action.payload.data.linkSource,
        email: action.payload.data.email,
      };
    },
    [initDeactivationConfirmationPage.toString()]: (
      state,
      action: ReturnType<typeof initDeactivationConfirmationPage>
    ) => {
      return {
        ...state,
        step: DeactivateAccountWidgetStep.VerificationSuccess,
        linkSource: action.payload.data.emailLinkSource,
        confirmation: {
          emailToken: action.payload.data.emailToken,
          emailTokenTs: action.payload.data.emailTokenTs,
          presetReasons: action.payload.data.presetReasons,
        },
      };
    },
    [setDeactivateAccountWidgetStep.toString()]: (
      state,
      action: ReturnType<typeof setDeactivateAccountWidgetStep>
    ) => ({
      ...state,
      step: action.payload.step,
    }),
    ...networkRequestMetaReducer({
      initialAction: submitSendVerificationEmailModal,
      successAction: submitSendVerificationEmailModalSuccess,
      failureAction: submitSendVerificationEmailModalFailure,
    }),
    ...networkRequestMetaReducer({
      initialAction: submitConfirmDeactivationModal,
      successAction: submitConfirmDeactivationModalSuccess,
      failureAction: submitConfirmDeactivationModalFailure,
    }),
    ...networkRequestMetaReducer({
      initialAction: submitReactivate,
      successAction: submitReactivateSuccess,
      failureAction: submitReactivateFailure,
    }),
  },
  defaultDeactivateAccountWidgetState
);
